<template>
	<div class="widgets-container">
		<div class="widgets-items">
			<!--div class="widget-item">
				<a @click="enableWidget('gmaps')">
					<img src="images/wid-weat-3.png" alt="">
				</a>
			</div-->
			<div class="widget-item">
				<a @click="enableWidget('weather')">
					<img src="images/wid-weat-3.png" alt="">
				</a>
			</div>
			<div class="widget-item">
				<a @click="enableWidget('calc')">
					<img src="images/wid-calc-3.png" alt="">
				</a>
			</div>
			<div class="widget-item">
				<a @click="enableWidget('calendar')">
					<img src="images/wid-cal-3.png" alt="">
				</a>
			</div>
			<div class="widget-item">
				<a @click="enableWidget('currency')">
					<img src="images/wid-exch-3.png" alt="">
				</a>
			</div>
			<div class="widget-item">
				<a @click="enableWidget('translate')">
					<img src="images/wid-trans-3.png" alt="">
				</a>
			</div>
		</div>
		<div v-if="widgetEnabled=='gmaps'" class="widget-wrapper widget-wrapper-gmaps theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<div v-if="geolocation">
				<iframe :src="'https://maps.google.com/maps?q='+geolocation.latitude+','+geolocation.longitude+'&z=13&output=embed'"></iframe>
			</div>
		</div>
		<div v-if="widgetEnabled=='weather'" class="widget-wrapper widget-wrapper-weather theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<!-- <spen>Geolocation: {{ geolocation.latitude }} {{ geolocation.longitude }}</span> -->
			<iframe v-if="geolocation" :src="'https://www.urlinks.com.br/geolocation/geolocation.php?lat='+geolocation.latitude+'&lng='+geolocation.longitude"></iframe>
		</div>
		<div v-if="widgetEnabled=='translate'" class="widget-wrapper widget-wrapper-translate theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<iframe src="https://www.bing.com/translator"></iframe>
		</div>

		<div v-if="widgetEnabled=='calc'" class="widget-wrapper widget-wrapper-calc theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<iframe src="https://web2.0calc.com/widgets/7f14a788f4c5/"></iframe>
		</div>
		<div v-if="widgetEnabled=='calendar'" class="widget-wrapper widget-wrapper-calendar theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<iframe src="/widgets/calendar.html"></iframe>
		</div>
		<div v-if="widgetEnabled=='currency'" class="widget-wrapper widget-wrapper-currency theme-bg-3">
			<span class="widget-close" @click="closeWidget">&times;</span>
			<iframe src="/widgets/currency.html"></iframe>
		</div>
	</div>
</template>

<style>

.widgets-content{  }
.widgets-items{  }
.widget-item{ position: relative; margin-bottom:10px; }
.widget-item a{ color:#fff; font-size:.8em; }
.widget-item a img {  }

.widget-close {position: absolute; cursor: pointer; top: -10px; right: -10px; height: 20px; width: 20px; text-align: center; line-height: 20px; background: #fff; color: #333; border-radius: 50%; box-shadow: 0 0 3px rgba(0,0,0,.3); }
.widget-wrapper {position: absolute; top: 0; left: 0; width: 450px; z-index: 6; padding: 10px; box-shadow: 5px 5px 10px rgba(0,0,0,.6); }
.widget-wrapper iframe{ display: block; width:100%; }


.widget-wrapper-weather {  }
.widget-wrapper-weather >div { background: #fff;  }
.widget-wrapper-weather iframe { height:520px; }
.widget-wrapper-translate { width:1160px; }
.widget-wrapper-translate iframe { height:490px; }
.widget-wrapper-calc { width:600px; }
.widget-wrapper-calc iframe { height:340px; }
.widget-wrapper-calendar {  }
.widget-wrapper-calendar iframe { height:570px; }
.widget-wrapper-currency {  }
.widget-wrapper-currency iframe { height:330px; }


.is-mobile .widgets-container { display: flex; flex-direction: column; height:100%; }
.is-mobile .widgets-items { display: flex; margin:5px; flex-shrink: 0; }
.is-mobile .widget-item { margin:0; }
.is-mobile .widget-wrapper { position: relative; flex-grow: 1; width: auto; }
.is-mobile .widget-wrapper iframe { width: 100%; height:100%; }
.is-mobile .widget-close {top: -10px; right: 0px; }
</style>

<script>

	export default {

		data() {
			return {
				widgetEnabled:null,
				geolocation:null,
			}
		},
		methods:{
			enableWidget(name){
				this.widgetEnabled = name;
				if(name=='weather' || name=='gmaps'){
					navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError);
				}
			},
			locationSuccess(position) {
				this.geolocation = position.coords;
			},
			locationError(error) {
				alert("Error Code: " + error.cod+" Error Message: " + error.message);
			},

			closeWidget(){
				this.widgetEnabled = null
			},
		},
	}

</script>
